import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
//Machines
import ToolsMachine from "../Tools/Machines/ToolsMachine";
// SYSTEM1/
import Loader from "@/components/widgets/loader.vue";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "../BaseMixer";
import { ToolGridViewModel } from "@/store/models/tools/Tools";
import ToolModule from "@/store/modules/tool.module";
import { toaster } from "../../../utilities/toaster";
import { interpret } from "xstate";
import DeleteComponent from "@/components/deleteComponent.vue";
let Tools = /** @class */ (() => {
    let Tools = class Tools extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.title = "Tools";
            this.items = [
                {
                    text: "Tools",
                },
                {
                    text: "ToolsList",
                    active: true,
                },
            ];
            this.showDeleteModal = false;
            this.pageIsLoading = true;
            this.tool = new ToolGridViewModel();
            //Machines
            // MACHINE
            this.machine = ToolsMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        AddTool() {
            this.$router.push({ name: "ToolAdd" });
        }
        editTool(toolid) {
            this.$router.push({ name: "UpdateTool", params: { id: toolid } });
        }
        viewTool(toolid) {
            this.$router.push({ name: "ViewTool", params: { id: toolid } });
        }
        deleteTool() {
            ToolModule.DeleteTool(this.delValueId).then((response) => {
                toaster.ShowSuccess("Tool was deleted successfully. ");
                ToolModule.GetTools().then((response) => { });
            });
            this.showDeleteModal = false;
        }
        openDeleteModal(valueId) {
            this.delValueId = valueId;
            this.showDeleteModal = true;
            this.pageIsLoading = false;
        }
        cancelTool() {
            this.showDeleteModal = false;
        }
        // COMPUTED
        get tools() {
            return ToolModule.tools;
        }
        // LIFECYCLE
        created() {
            this.machineService.onTransition((state) => {
                this.state = state;
            });
            this.machineService.start();
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    Tools = __decorate([
        Component({
            name: "Tools",
            components: {
                Layout,
                PageHeader,
                Loader,
                DeleteComponent,
            },
        })
    ], Tools);
    return Tools;
})();
export default Tools;
